import React from 'react';
import { Brief } from '@axiom/ui';
import type { TalentSearchDisplayFiltersCategory } from '@axiom/validation';

import { TalentSearchFiltersTemplate } from './TalentSearchFiltersTemplate';

export interface TalentSearchFiltersCheckboxesProps {
  data?: TalentSearchDisplayFiltersCategory['items'];
  disabled: boolean;
  groupingName?: string;
  parentIndex: number;
}

export const TalentSearchFiltersCheckboxes = ({
  data,
  disabled,
  parentIndex,
  groupingName,
}: TalentSearchFiltersCheckboxesProps) => {
  const alwaysShowArray = data && 'alwaysShow' in data ? data.alwaysShow : [];
  const showHideArray = data && 'showHide' in data ? data.showHide : [];
  return (
    <Brief
      name="SHOW_MORE_LESS_CHECKBOX"
      position="left"
      briefMaxChildren={alwaysShowArray.length + 1}
      pattern="secondary"
    >
      {alwaysShowArray.map((item, index) => (
        <div key={JSON.stringify(item.id)} data-test="alwaysShowCheckbox">
          <TalentSearchFiltersTemplate
            item={item}
            index={item.originalIndex ?? index}
            parentIndex={parentIndex}
            disabled={disabled}
            area="alwaysShow"
            groupingName={groupingName}
            key={JSON.stringify(item.id)}
          />
        </div>
      ))}
      {showHideArray.map((item, index) => (
        <div key={JSON.stringify(item.id)} data-test="showHideCheckbox">
          <TalentSearchFiltersTemplate
            key={JSON.stringify(item.id)}
            item={item}
            index={item.originalIndex ?? index}
            parentIndex={parentIndex}
            disabled={disabled}
            area="showHide"
            groupingName={groupingName}
          />
        </div>
      ))}
    </Brief>
  );
};
